import AccessDeviceIcon from '@material-ui/icons/ViewList';

import AdmissionSttConfigList from './AdmissionSttConfigList';
import AdmissionSttConfigCreate from './AdmissionSttConfigCreate';
import AdmissionSttConfigEdit from './AdmissionSttConfigEdit';

export default {
  list: AdmissionSttConfigList,
  create: AdmissionSttConfigCreate,
  edit: AdmissionSttConfigEdit,
  icon: AccessDeviceIcon,
};
